// The navigation surface the UI is written against — the Next.js App Router
// API it was built on, implemented over react-router. One module per Next
// module (next/link → @/nav/link, next/navigation → @/nav/navigation,
// next/dynamic → @/nav/dynamic, next's Metadata → @/nav/metadata), so the UI
// split (Phase 3) changed import paths and nothing else, test mocks included.
// New code may use react-router directly; this stays where the two meet.

/** Paths the API pod answers itself. A client-side transition to one would
 *  land on the SPA's not-found page, so they are always a real page load. */
const SERVER_PATH_RE = /^\/(api|_brand|brand-assets|r|health)(\/|$|\?)/;
/** Any scheme (https:, mailto:, tel:) or a protocol-relative URL. */
const EXTERNAL_RE = /^([a-z][a-z0-9+.-]*:|\/\/)/i;

/** True when `href` must leave the SPA (a full navigation). */
export function isHardHref(href: string): boolean {
  return EXTERNAL_RE.test(href) || SERVER_PATH_RE.test(href);
}
